import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function toPromise(_x) {
  return _toPromise.apply(this, arguments);
}
function _toPromise() {
  _toPromise = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(callback) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", callback());
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _toPromise.apply(this, arguments);
}
function getScheduler(obj) {
  if ('scheduler' in obj && obj.scheduler !== 'undefined') {
    return obj.scheduler;
  }
}

// TODO Use the postTask type for the callback and return type once the current TypeScript version supports
//  forwarding the generic to the function (>=v4.7.4)
export function postTask(callback, options) {
  // Dynamically import the scheduler-polyfill module, so browsers that do support the Prioritized Task Scheduling API
  // do not pay the performance cost (e.g. bundle size, runtime, etc).
  var scheduler = getScheduler(globalThis);
  if (!scheduler) {
    // Only load the polyfill if we are using the background priority
    if (options.priority === 'background') {
      // This polyfill will be removed once the Prioritized Task Scheduling API is more widely supported in browsers.
      // eslint-disable-next-line import/dynamic-import-chunkname
      // @ts-ignore error TS7016: Could not find a declaration file for module 'scheduler-polyfill' seen in Jira Typechecking (Cypress) step
      return import('scheduler-polyfill').then(function () {
        return getScheduler(globalThis).postTask(callback, options);
      });
    }
    return toPromise(callback);
  }
  return scheduler.postTask(callback, options);
}